import { PageTypeAdmin } from "@/lib/types";

export type UserTasksNavBadge = {
  count: number;
  tooltipSuffix: string;
};

export function isMyTasksNavHref(href: string): boolean {
  return href === PageTypeAdmin.Tasks;
}

export function groupContainsMyTasksNav(
  items: ReadonlyArray<{ href: string }>,
): boolean {
  return items.some((item) => isMyTasksNavHref(item.href));
}

export function buildUserTasksNavBadgeLabel(
  itemLabel: string,
  badge: UserTasksNavBadge,
): string {
  const countLabel = badge.count > 9 ? "9+" : String(badge.count);
  return `${itemLabel} (${countLabel} ${badge.tooltipSuffix})`;
}
